import NumberFormat from 'react-number-format'

import { Flex, Text, Input } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

const NumberInputCell = ({
  getValue,
  table,
  row: { index: rowIndex },
  column: { id: columnId },
  extraDisable = false,
  forceEnable = false,
  decimalScale = 0,
  pricePrefix = '',
}) => {
  const cellValue = getValue() ?? ''

  const [localValue, setLocalValue] = useState(cellValue)
  const isDisabled = !forceEnable && (table.options.meta?.disabled || extraDisable)

  useEffect(() => {
    if (cellValue) {
      setLocalValue(cellValue)
    }
  }, [cellValue])
  const onChange = ({ value }) => {
    const floatValue = parseFloat(value)

    setLocalValue(isNaN(floatValue) ? undefined : floatValue)
  }

  const onBlur = () => {
    if (localValue !== cellValue) {
      // Defer update to the next tick so click-to-focus on the next cell can complete first.
      setTimeout(() => {
        table.options.meta?.updateData(rowIndex, columnId, localValue)
      }, 0)
    }
  }

  if (isDisabled) {
    return (
      <Text>
        {pricePrefix}
        {localValue}
      </Text>
    )
  }
  return (
    <Input
      as={NumberFormat}
      placeholder="Enter"
      thousandSeparator
      allowNegative={false}
      decimalScale={decimalScale}
      value={localValue}
      onValueChange={onChange}
      onBlur={onBlur}
      bg={'white'}
    ></Input>
  )
}

export default NumberInputCell
